import store from '../../store/index'
import observeSession from '../../common/utils/observe'
// 基准大小
const baseSize = 100

// 设置 rem 函数
function setRem () {
  let vW = window.innerWidth
  if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i) && vW < 768) {
    // alert('手机端')
    const deviceType = 'mobile'
    store.commit('setDeviceType', deviceType)
    // 当前页面宽度相对于 320 宽的缩放比例，可根据自己需要修改。
    const scale = document.documentElement.clientWidth / 320
    // 设置页面根节点字体大小
    document.documentElement.style.fontSize = baseSize * Math.min(scale, 2) + 'px'
  } else {
    // alert('PC端')
    const deviceType = 'pc'
    store.commit('setDeviceType', deviceType)
    const basePc = baseSize / 1920 // 表示1920的设计图,使用100PX的默认值
    if (vW <= 1920) {
      const rem = 1920 * basePc
      document.documentElement.style.fontSize = rem + 'px'
    } else {
      const rem = vW * basePc
      document.documentElement.style.fontSize = rem + 'px' // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
    }
  }
}

// 初始化
setRem()

// 改变窗口大小时重新设置 rem
window.onresize = function () {
  observeSession.emmit('windowChange', {width: window.innerWidth, height: window.innerHeight})
  setRem()
}



// WEBPACK FOOTER //
// ./src/common/utils/rem.js